import * as qs from 'qs';
import request from '../utils/request';

// 获取当前用户信息
export const getUserInfo = () => request('/admin/user/cur-user');
// 检测用户
export const checkAccount = () => request('/admin/user/check-account');
// 获取用户列表
export const getUserList = (param) => request(`/admin/custom/user?${qs.stringify(param)}`);
// 微信用户详情
export const getWxUserDetail = (id) => request(`/admin/custom/user/${id}`);
// 获取快递员
export const partnerList = (param) => request(`/admin/partner?${qs.stringify(param)}`);
// 快递员审核
export const auditPartner = ({ id, type }) => request(`/admin/partner/audit/${id}/${type}`, {
  method: 'put',
});
// 快递员充值
export const recharge = (id, value) => request({
  method: 'put',
  url: `/admin/partner/recharge/${id}`,
  data: { value },
});
// 获取管理端用户数据
export const getAdminUser = (param) => request(`/admin/user?${qs.stringify(param)}`);
// 添加用户
export const addUser = (data) => request({
  url: '/admin/user',
  method: 'post',
  data,
});
// 修改用户
export const modifyUser = (id, data) => request({
  url: `/admin/user/${id}`,
  method: 'put',
  data,
});
// 获取详情
export const getUserDetail = (id) => request(`/admin/user/${id}`);
// 重置密码
export const resetPassword = (id) => request({
  url: `/admin/user/password-reset/${id}`,
  method: 'put',
});
// 解绑用户电话
export const unbinMobile = (id) => request({
  url: `/admin/user/unbin-mobile/${id}`,
  method: 'put',
});
// 站点客户
export const stationUser = (param) => request(`/admin/custom/index?${qs.stringify(param)}`);
export const confirmUser = (param) => request(`/admin/comfirm-customer/list?${qs.stringify(param)}`);
export const comfirmCustomer = (param) => request(`/admin/comfirm-customer`, {
  method: 'put',
  data: param,
});
// 获取相似客户
// 获取相似客户
export const getSecretUser = (param) => request(`/admin/custom/secret-phone-custom?${qs.stringify(param)}`);
// 设置相似客户电话
export const setSecretUser = (customId, phone) => request({
  method: 'put',
  url: `/admin/custom/secret-phone-custom/${customId}`,
  data: { phone },
});
export const deleteCustom = (id) => request({
  method: 'delete',
  url: `/admin/custom/user/${id}`,
});
// 编辑站点用户黑名单
export const shieldStationUser = (id, data) => request({
  url: `/admin/custom/shield/${id}`,
  method: 'put',
  data,
});
// 站点快递员
export const stationPartnerList = (id) => request(`/admin/partner/station-partner?station=${id}`);
// upodate tages
export const updateTages = (id, data) => request({
  url: `/admin/custom/tages/${id}`,
  method: 'put',
  data,
});

export const updateCustomerName = (phone, station) => request({
  url: `/admin/custom/update-name-by-phone/${station}/${phone}`,
  method: 'put',
});

export const updateCustomer = (data) => request({
  url: `/admin/custom/${data.id}`,
  method: 'put',
  data,
});

export const creatCustomer = (data) => request({
  url: `/admin/custom`,
  method: 'post',
  data,
});
export const deleteCustomer = (id) => request({
  url: `/admin/custom/user/${id}`,
  method: 'delete',
});

// guss
export const gussCustomer = (param) => request(`/admin/package/secret-phone/take?${qs.stringify(param)}`);
// changePatner

export const changePatnerAction = (id) => request({
  url: `/admin/packages/change-partner/${id}`,
  method: 'put',
});
